/**
 * Shared character name sanitization / placeholder detection for rankings + hangout resume.
 */

import { pickSlotCharacterName } from '../../utils/character-name-tokens.js';

export const sanitizeCharacterName = (value) => {
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  if (!trimmed) return null;
  return trimmed;
};

export const isPlaceholderCharacterName = (name, characterId = null) => {
  const sanitizedName = sanitizeCharacterName(name);
  if (!sanitizedName) return true;

  const lower = sanitizedName.toLowerCase();
  if (lower === 'character' || lower === 'unknown') return true;
  if (/^character\s+\d+$/i.test(sanitizedName)) return true;
  if (/^\d+$/.test(sanitizedName)) return true;

  if (characterId !== null && characterId !== undefined) {
    const normalizedCharacterId = String(characterId).trim();
    if (normalizedCharacterId && sanitizedName === normalizedCharacterId) return true;
  }

  return false;
};

export const pickResolvedCharacterName = (character, characterId = null) => {
  if (!character || typeof character !== 'object') return '';
  const id = characterId ?? character.id ?? character.character_id;
  const aliases = pickSlotCharacterName(character);
  if (aliases && !isPlaceholderCharacterName(aliases, id)) return aliases;
  return '';
};
